"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOGGLE_STRIKE_OPTIONS = exports.optimisticEndMarksheet = exports.updateCacheOnEndMarksheet = exports.END_MARKSHEET = exports.LEAVE_MARKSHEET = exports.MODIFY_CURRENT_MARKSHEET_MARK = exports.MODIFY_MARKSHEET_MARK_QUESTIONCHOICEID = exports.MODIFY_MARKSHEET_MARK_STRIKED = exports.MODIFY_MARKSHEET_MARK = exports.MODIFY_MARKSHEET_STATE = exports.MODIFY_TOPIC_SELECTION = exports.MODIFY_BUILDER_CONFIG = exports.MODIFY_MARKSHEET = exports.optimisticModifyMarksheetBuilderConfig = exports.START_OR_JOIN_MARKSHEET = exports.optimisticRemoveFlaggedQuestion = exports.updateCacheRemoveFlaggedQuestion = exports.optimisticAddFlaggedQuestion = exports.updateCacheAddFlaggedQuestion = exports.REMOVE_FLAGGED_QUESTION = exports.ADD_FLAGGED_QUESTION = exports.optimisticSaveMarksheets = exports.updateMarksheets = exports.SAVE_MARKSHEET = exports.QUICK_BUILD_MARKSHEET = exports.RE_BUILD_MARKSHEET = exports.BUILD_UCAT_MARKSHEET = exports.BUILD_MARKSHEET = exports.BUILD_QUESTION_MARKSHEET = void 0;
const client_1 = require("@apollo/client");
const marksheet_1 = require("../../fragments/marksheet");
const restricted_1 = require("../../query/restricted");
exports.BUILD_QUESTION_MARKSHEET = (0, client_1.gql) `
  ${marksheet_1.MARKSHEET_FIELDS}
  mutation BuildQuestionMarksheet($questionIds: [Int!]) {
    restricted {
      buildQuestionMarksheet(questionIds: $questionIds) {
        ...MarksheetFields
      }
    }
  }
`;
exports.BUILD_MARKSHEET = (0, client_1.gql) `
  ${marksheet_1.MARKSHEET_FIELDS}
  mutation BuildMarksheet($input: BuildMarksheetInput!) {
    restricted {
      buildMarksheet(input: $input) {
        ...MarksheetFields
      }
    }
  }
`;
exports.BUILD_UCAT_MARKSHEET = (0, client_1.gql) `
  ${marksheet_1.MARKSHEET_FIELDS}
  mutation BuildUcatMarksheet($input: BuildUcatMarksheetInput!) {
    restricted {
      buildUcatMarksheet(input: $input) {
        ...MarksheetFields
      }
    }
  }
`;
/**
 * reBuildMarksheet
 */
exports.RE_BUILD_MARKSHEET = (0, client_1.gql) `
  ${marksheet_1.MARKSHEET_FIELDS}
  mutation ReBuildMarksheet($marksheetId: Int!) {
    restricted {
      reBuildMarksheet(marksheetId: $marksheetId) {
        ...MarksheetFields
      }
    }
  }
`;
exports.QUICK_BUILD_MARKSHEET = (0, client_1.gql) `
  ${marksheet_1.MARKSHEET_FIELDS}
  mutation QuickBuildMarksheet($input: QuickBuildMarksheetInput) {
    restricted {
      quickBuildMarksheet(input: $input) {
        ...MarksheetFields
      }
    }
  }
`;
/**
 * saveMarksheets
 */
exports.SAVE_MARKSHEET = (0, client_1.gql) `
  mutation SaveMarksheet($input: [SaveMarksheetInput!]!) {
    restricted {
      saveMarksheets(input: $input) {
        id
        createdAt
        solo
        state
        marks {
          isAnswered
          id
          marksheetId
          questionChoiceId
          timeTaken
          flagged
          mark
        }
        correct
        incorrect
      }
    }
  }
`;
const updateMarksheets = (cache, result, options) => {
    const { saveMarksheets } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!options || !variables || !saveMarksheets) {
        return;
    }
    try {
        for (let i = 0; i < saveMarksheets.length; i++) {
            const { input } = variables;
            const marksheet = input[i];
            cache.writeFragment({
                id: cache.identify({
                    id: saveMarksheets[i],
                    __typename: 'MarksheetMark',
                }),
                data: {
                    timeTaken: marksheet.timeTaken || 0,
                    mark: marksheet.mark,
                    questionChoiceId: marksheet.choiceId,
                    isAnswered: true,
                },
                fragment: marksheet_1.NEW_MARK_FIELDS,
            });
        }
    }
    catch (error) {
        console.error(error);
    }
};
exports.updateMarksheets = updateMarksheets;
const optimisticSaveMarksheets = (marksheet, marksheetInput, questionIndex) => {
    const { timeTaken, choiceId, mark, marksheetId } = marksheetInput;
    const { marks = [], ...rest } = marksheet || {};
    const updatedMark = {
        ...marks[questionIndex],
        marksheetId,
        timeTaken,
        questionChoiceId: choiceId ?? null,
        isAnswered: true,
        mark: mark || null,
    };
    const updatedMarks = [
        ...marks.slice(0, questionIndex),
        updatedMark,
        ...marks.slice(questionIndex + 1),
    ];
    return {
        restricted: {
            saveMarksheets: [{ ...rest, marks: updatedMarks }],
        },
    };
};
exports.optimisticSaveMarksheets = optimisticSaveMarksheets;
/**
 * addFlaggedQuestion
 */
exports.ADD_FLAGGED_QUESTION = (0, client_1.gql) `
  mutation AddFlaggedQuestion(
    $markId: Int!
    $questionId: Int!
    $marksheetId: Int
  ) {
    restricted {
      addFlaggedQuestion(
        markId: $markId
        questionId: $questionId
        marksheetId: $marksheetId
      ) {
        id
        markId
      }
    }
  }
`;
/**
 * removeFlaggedQuestion
 */
exports.REMOVE_FLAGGED_QUESTION = (0, client_1.gql) `
  mutation RemoveFlaggedQuestion($questionId: Int!, $marksheetId: Int) {
    restricted {
      removeFlaggedQuestion(
        questionId: $questionId
        marksheetId: $marksheetId
      ) {
        id
        markId
      }
    }
  }
`;
const updateCacheAddFlaggedQuestion = (cache, result) => {
    const { addFlaggedQuestion } = result?.data?.restricted || {};
    if (!addFlaggedQuestion) {
        return;
    }
    const { markId } = addFlaggedQuestion;
    cache.writeFragment({
        id: cache.identify({ id: markId, __typename: 'MarksheetMark' }),
        data: {
            flagged: true,
        },
        fragment: marksheet_1.MARK_FLAGGED_FIELD,
    });
};
exports.updateCacheAddFlaggedQuestion = updateCacheAddFlaggedQuestion;
const optimisticAddFlaggedQuestion = (id, markId) => {
    const response = {
        createdAt: new Date(),
        id,
        markId,
    };
    return {
        restricted: {
            addFlaggedQuestion: {
                __typename: 'UserFlaggedQuestion',
                ...response,
            },
        },
    };
};
exports.optimisticAddFlaggedQuestion = optimisticAddFlaggedQuestion;
const updateCacheRemoveFlaggedQuestion = (cache, result) => {
    const { removeFlaggedQuestion } = result?.data?.restricted || {};
    if (!removeFlaggedQuestion) {
        return;
    }
    removeFlaggedQuestion.forEach(({ markId }) => {
        cache.writeFragment({
            id: cache.identify({ id: Number(markId), __typename: 'MarksheetMark' }),
            data: {
                flagged: false,
            },
            fragment: marksheet_1.MARK_FLAGGED_FIELD,
        });
    });
};
exports.updateCacheRemoveFlaggedQuestion = updateCacheRemoveFlaggedQuestion;
const optimisticRemoveFlaggedQuestion = (id, markId) => {
    const response = {
        id,
        markId,
    };
    return {
        restricted: {
            removeFlaggedQuestion: [
                {
                    __typename: 'UserFlaggedQuestion',
                    ...response,
                },
            ],
        },
    };
};
exports.optimisticRemoveFlaggedQuestion = optimisticRemoveFlaggedQuestion;
exports.START_OR_JOIN_MARKSHEET = (0, client_1.gql) `
  mutation StartOrJoinMarksheet($sessionId: String!, $action: Int!) {
    restricted {
      startOrJoinMarksheet(sessionId: $sessionId, action: $action) {
        id
        agoraId
        sessionId
        activeUsers {
          id
          displayName
        }
      }
    }
  }
`;
const optimisticModifyMarksheetBuilderConfig = (marksheetId, builderConfig, client) => {
    const data = client?.readQuery({
        variables: { id: Number(marksheetId) },
        query: restricted_1.MARKSHEET,
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { marksheet } = data.restricted;
    const newBuilderConfig = { ...marksheet.builderConfig, ...builderConfig };
    return {
        restricted: {
            __typename: 'RestrictedMutation',
            modifyMarksheet: {
                ...marksheet,
                builderConfig: newBuilderConfig,
            },
        },
    };
};
exports.optimisticModifyMarksheetBuilderConfig = optimisticModifyMarksheetBuilderConfig;
exports.MODIFY_MARKSHEET = (0, client_1.gql) `
  ${marksheet_1.BUILDER_CONFIG_FIELDS}
  mutation ModifyMarksheet($input: ModifyMarksheetInput) {
    restricted {
      modifyMarksheet(input: $input) {
        id
        createdAt
        startedAt
        endedAt
        state
        completed
        currentMarkId
        topicConceptData
        builderConfig {
          ...BuilderConfigFields
        }
      }
    }
  }
`;
/**
 * MODIFY_BUILDER_CONFIG
 */
exports.MODIFY_BUILDER_CONFIG = (0, client_1.gql) `
  ${marksheet_1.BUILDER_CONFIG_FIELDS}
  mutation ModifyMarksheetBuilderConfig($input: ModifyMarksheetInput) {
    restricted {
      modifyMarksheet(input: $input) {
        id
        builderConfig {
          ...BuilderConfigFields
        }
      }
    }
  }
`;
/**
 * MODIFY_TOPIC_SELECTION
 */
exports.MODIFY_TOPIC_SELECTION = (0, client_1.gql) `
  mutation ModifyMarksheetTopicSelection($input: ModifyMarksheetInput) {
    restricted {
      modifyMarksheet(input: $input) {
        id
        topicConceptData
      }
    }
  }
`;
/**
 * MODIFY_MARKSHEET_STATE
 */
exports.MODIFY_MARKSHEET_STATE = (0, client_1.gql) `
  mutation ModifyMarksheetState($input: ModifyMarksheetInput) {
    restricted {
      modifyMarksheet(input: $input) {
        id
        state
      }
    }
  }
`;
exports.MODIFY_MARKSHEET_MARK = (0, client_1.gql) `
  mutation ModifyMarksheetMark($input: ModifyMarksheetMarkInput) {
    restricted {
      modifyMarksheetMark(input: $input) {
        id
        createdAt
        updatedAt
        index
        marksheetId
        questionChoiceId
        timeTaken
        mark
        isAnswered
        striked
      }
    }
  }
`;
exports.MODIFY_MARKSHEET_MARK_STRIKED = (0, client_1.gql) `
  mutation ModifyMarksheetMarkStriked($input: ModifyMarksheetMarkInput) {
    restricted {
      modifyMarksheetMark(input: $input) {
        id
        striked
      }
    }
  }
`;
exports.MODIFY_MARKSHEET_MARK_QUESTIONCHOICEID = (0, client_1.gql) `
  mutation ModifyMarksheetMarkQuestionChoiceId(
    $input: ModifyMarksheetMarkInput
  ) {
    restricted {
      modifyMarksheetMark(input: $input) {
        id
        questionChoiceId
      }
    }
  }
`;
exports.MODIFY_CURRENT_MARKSHEET_MARK = (0, client_1.gql) `
  mutation ModifyCurrentMarksheetMark($input: ModifyMarksheetMarkInput) {
    restricted {
      modifyMarksheetMark(input: $input) {
        id
        index
        timeTaken
      }
    }
  }
`;
exports.LEAVE_MARKSHEET = (0, client_1.gql) `
  mutation LeaveMarksheet($marksheetId: Int!) {
    restricted {
      leaveMarksheet(marksheetId: $marksheetId) {
        id
      }
    }
  }
`;
exports.END_MARKSHEET = (0, client_1.gql) `
  mutation EndMarksheet($marksheetId: Int!) {
    restricted {
      endMarksheet(marksheetId: $marksheetId) {
        id
        timeTaken
        startedAt
        endedAt
        completed
        passingMark
        duration
        correct
        incorrect
        totalQuestions
      }
    }
  }
`;
const updateCacheOnEndMarksheet = (cache, result, options) => {
    const { endMarksheet } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !endMarksheet) {
        return;
    }
    const { marksheetId: id } = variables;
    cache.writeFragment({
        id: cache.identify({ id, __typename: 'Marksheet' }),
        data: {
            completed: true,
            timeTaken: endMarksheet.timeTaken,
            correct: endMarksheet.correct,
            incorrect: endMarksheet.incorrect,
            duration: endMarksheet.duration,
            endedAt: endMarksheet.endedAt,
        },
        fragment: marksheet_1.MODIFY_MARKSHEET_COMPLETED_FRAGMENT,
    });
};
exports.updateCacheOnEndMarksheet = updateCacheOnEndMarksheet;
const optimisticEndMarksheet = (marksheet) => ({
    restricted: {
        __typename: 'RestrictedMutation',
        endMarksheet: {
            __typename: 'Marksheet',
            ...marksheet,
            completed: true,
        },
    },
});
exports.optimisticEndMarksheet = optimisticEndMarksheet;
exports.TOGGLE_STRIKE_OPTIONS = (0, client_1.gql) `
  mutation ToggleStrikeOptions($input: [ToggleStrikeOptionsInput!]!) {
    restricted {
      toggleStrikeOptions(input: $input) {
        createdAt
        flagged
        id
        index
        isAnswered
        mark
        marksheetId
        question {
          id
          choices {
            id
          }
        }
        questionChoiceId
        questionId
        striked
        timeTaken
        updatedAt
      }
    }
  }
`;
